/* global axios */
import ApiClient from './ApiClient';

class FollowUpAutomationsAPI extends ApiClient {
  constructor() {
    super('follow-up-automations', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(automationId) {
    return axios.get(`${this.url}/${automationId}`);
  }

  create(data) {
    return axios.post(this.url, { follow_up_automation: data });
  }

  update(automationId, data) {
    return axios.patch(`${this.url}/${automationId}`, {
      follow_up_automation: data,
    });
  }

  delete(automationId) {
    return axios.delete(`${this.url}/${automationId}`);
  }
}

export default new FollowUpAutomationsAPI();
